<div
  [routerLink]="tabRouterLink"
  routerLinkActive="active-tab accent-font"
  class="content-wrap"
  [ngClass]="interactionDisabled ? 'disabled' : ''"
  [ngClass]="gameTenantKind === 'Company' ? 'company-bg' : 'school-bg'"
>
  <div><ng-content></ng-content></div>
</div>
